export const geoJsonFilePath = 'data/qld_sa4s.geo.json';
export const hhsDataFilePath = 'data/hhs-data.json';
export const dataFilePath = 'data/edu_data.json';



// WEBPACK FOOTER //
// ./src/config/index.js